import React from "react";
import MobileModal from "repoV2/components/common/Modal/MobileModal";
import ModalContent from "repoV2/components/common/Modal/ModalContent";
import ModalHeader from "repoV2/components/common/Modal/ModalHeader";
import ModalBody from "repoV2/components/common/Modal/ModalBody";
import commonStyles from "repoV2/features/CheckoutPages/CheckoutCommonStyles.module.scss";
import styles from "./CheckoutMobileFormModal.module.scss";

type ICheckoutMobileFormModalProps = {
    isModalOpen: boolean;
    onClose?: () => void;
    title?: string;
    children: React.ReactNode;
};
const CheckoutMobileFormModal = ({
    isModalOpen,
    onClose = () => {},
    title = "",
    children,
}: ICheckoutMobileFormModalProps) => {
    return (
        <MobileModal
            open={isModalOpen}
            // disablePortal is enabled to enable SSR of MUI Drawer component
            // check - https://mui.com/material-ui/react-modal/#server-side-modal
            disablePortal
            onClose={onClose}
            className={commonStyles.hideInDesktop}
            ModalProps={{
                disableScrollLock: true, // This prop stops MUI drawer from preventing the scroll bar on the
                // base page, otherwise in desktop view, when the modal does not render because of 'hideInDesktop' style
                // in parent component, the scroll bar would not appear and the page would be overflow-hidden. This prop disables that
            }}
        >
            <ModalContent className={styles.ModalContent}>
                <ModalHeader
                    showCloseIcon
                    onClose={onClose}
                    classes={{
                        header: styles.ModalHeader,
                        title: styles.ModalTitle,
                        close: styles.closeIconStyle,
                    }}
                >
                    {title}
                </ModalHeader>
                <ModalBody className={styles.ModalBody}>{children}</ModalBody>
            </ModalContent>
        </MobileModal>
    );
};

CheckoutMobileFormModal.defaultProps = {
    onClose: () => {},
    title: "",
};

export default CheckoutMobileFormModal;
